export enum UserEnum {
  userInfo = 'SignUp/UserInfo' // 取得、更新使用者資訊
}
